/* istanbul ignore file */
import { DropDownFilter, BaseFilterProps } from 'framework/list';
import React from 'react';
import PurchaseOrderTypeDropdown from 'domain/finance/purchaseOrder/shared/input/PurchaseOrderTypeDropdown';

const PurchaseOrderTypeFilter = ({ source, ...props }: BaseFilterProps & { label: string }) => {
  return (
    <DropDownFilter {...props} source={source}>
      <PurchaseOrderTypeDropdown source={source} />
    </DropDownFilter>
  );
};

export default PurchaseOrderTypeFilter;
